import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { noop } from 'Helpers/PropTypes';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1, 2),
  },
});

const Layout = ({
  className,
  classes,
  loading,
  onSubmit,
}) => {
  const { resource } = useMetaLayoutContext();
  const attributes = resource.attributes();
  const attributesArray = Object.keys(attributes);

  return (
    <div
      className={classNames(classes.root, className)}
    >
      {attributesArray.map(attr => (
        <MetaControlField key={attr} attr={attr} resource={resource} />
      ))}
      <RoundedButton
        padding={'dense'}
        fullWidth
        isLoading={loading}
        onClick={onSubmit}
      >
        {'Search'}
      </RoundedButton>
    </div>
  );
};

Layout.defaultProps = {
  className: '',
  onSubmit: noop,
};

Layout.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func,
};

export default withStyles(styles)(Layout);
